import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'connected-apps-tab',
    templateUrl: './connected-apps-tab.component.html',
    styleUrls: ['./connected-apps-tab.component.css'],
    standalone: false
})
export class ConnectedAppsTabComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
